import { Pipe, PipeTransform } from '@angular/core';



@Pipe({
    name: 'boolYesNoTranslator',
    standalone: false
})
export class BoolYesNoTranslatorPipe implements PipeTransform {

    /**
     * Asynchronous pipe, transforms a boolean to localized string.
     */
    transform(value?: boolean): string {
        if (value == null) {
            return "";
        } else {
            if (value) {
                return "Ja";
            } else {
                return "Nej";
            }
        }
    }
}
